import { useRouter } from "next/router";
import { useOrganization } from "./useOrganization";
import { useScreenSize } from "flicket-ui";

// List of paths where the bottom navigation is shown
const visiblePaths = [
  "/",
  "/merchandise",
  "/memberships",
  "/account",
  "/tickets",
  "/tours/[tourId]",
];

/**
 * Hook to check if the bottom navigation should be visible
 * @returns true if the bottom navigation should be visible
 */
export const useBottomNavVisible = (): boolean => {
  const router = useRouter();
  const { organization } = useOrganization();

  // Path condition: only show on certain paths
  const isVisiblePath = visiblePaths.includes(router?.pathname);

  // Options condition: only show if more than one option is available
  const showMemberships = !!organization?.showMemberships;
  const showMerchandise = !!organization?.shopify;
  const hasMultipleOptions = showMemberships || showMerchandise;

  // Screen size condition: only show on mobile
  const isMobile = useScreenSize().isPhoneLandscapeDown;

  return isVisiblePath && hasMultipleOptions && isMobile;
};
